import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RosterServiceService {

  clarifier_low:number = 0;
  clarifier_high:number = 0;
  ideator_low:number = 0;
  ideator_high:number = 0;
  developer_low:number = 0;
  developer_high:number = 0;
  implementor_low:number = 0;
  implementor_high:number = 0;
  clarifier_neutral:number = 0;
  ideator_neutral:number = 0;
  developer_neutral:number = 0;
  implementor_neutral:number =0;
  integrator:number = 0;
  highest_score:number = 0;
  total_members:number = 0;
  date;
  args:any;
  
  constructor() { }

    public async setGraphData(currentTeam) {
    this.total_members = currentTeam.memberships_count;
    currentTeam?.memberships?.forEach(list => {
        if(list?.default_profile){
            if(list?.default_profile?.clarifier_score == 'Low'){
                this.clarifier_low = this.clarifier_low + 1;
                if( this.clarifier_low > this.highest_score ){
                    this.highest_score = this.clarifier_low;
                }
            }
  
            if(list?.default_profile?.clarifier_score == 'High'){
                this.clarifier_high = this.clarifier_high + 1;
                if( this.clarifier_high > this.highest_score ){
                    this.highest_score = this.clarifier_high;
                }
            }
  
            if(list?.default_profile.ideator_score == 'Low'){
                this.ideator_low = this.ideator_low + 1;
                if( this.ideator_low > this.highest_score ){
                    this.highest_score = this.ideator_low;
                }
            }
  
            if(list?.default_profile?.ideator_score == 'High'){
                this.ideator_high = this.ideator_high + 1;
                if( this.ideator_high > this.highest_score ){
                    this.highest_score = this.ideator_high;
                }
            }
  
            if(list?.default_profile.developer_score == 'Low'){
                this.developer_low = this.developer_low + 1;
                if( this.developer_low > this.highest_score ){
                    this.highest_score = this.developer_low;
                }
            }
  
            if(list?.default_profile?.developer_score == 'High'){
                this.developer_high = this.developer_high + 1;
                if( this.developer_high > this.highest_score ){
                    this.highest_score = this.developer_high;
                }
            }
  
            if(list?.default_profile?.implementer_score == 'Low'){
                this.implementor_low = this.implementor_low + 1;
                if( this.implementor_low > this.highest_score ){
                    this.highest_score = this.implementor_low;
                }
            }
  
            if(list?.default_profile?.implementer_score == 'High'){
                this.implementor_high = this.implementor_high + 1;
                if( this.implementor_high > this.highest_score ){
                    this.highest_score = this.implementor_high;
                }
            }
  
            //   neutral profiles
            if(list?.default_profile?.clarifier_score == 'Neutral') {
              this.clarifier_neutral += 1; 
            }
            if(list.default_profile.ideator_score == 'Neutral') {
              this.ideator_neutral += 1; 
            }
            if(list.default_profile.developer_score == 'Neutral') {
              this.developer_neutral += 1; 
            }
            if(list.default_profile.implementer_score == 'Neutral') {
              this.implementor_neutral += 1; 
            }
            if(list?.default_profile?.clarifier_score == 'Neutral' && list.default_profile.ideator_score == 'Neutral' && list.default_profile.developer_score == 'Neutral' && list.default_profile.implementer_score == 'Neutral'){
              this.integrator += 1;
            }
  
        }
  
    });
    // await this.setArgs(currentTeam)
    this.date = new Date();
    let name = currentTeam.name;
    let membershipcount = currentTeam.memberships_count;
    let org_id = currentTeam.organization_id;
    let org_name = currentTeam.organization_name;
    let date = String(this.date.getFullYear()) + String((this.date.getMonth() + 1)) + String(this.date.getDate());
    let time = String(this.date.getHours()) + String(this.date.getMinutes());
    this.args = {
      "function_name": "plus-GroupProfileFunction-6y5p4TgXuqZA",
      "invocation_type": "RequestResponse",
      "log_type": "None",
      "id": currentTeam.id,
      "template": "team_pf.html",
      "filename": org_name +'-' + currentTeam.id+ '-' + date + time,
      "memberships_count": membershipcount,
      "name": name,
      "organization_title": "Organization",
      "organization_id": org_id,
      "organization_name": org_name,
      "clarifier_low": this.clarifier_low ? this.clarifier_low : 0,
      "clarifier_neutral": this.clarifier_neutral ? this.clarifier_neutral : 0,
      "clarifier_high": this.clarifier_high ? this.clarifier_high : 0,
      "ideator_low": this.ideator_low ? this.ideator_low : 0,
      "ideator_neutral": this.ideator_neutral ? this.ideator_neutral : 0,
      "ideator_high": this.ideator_high ?  this.ideator_high : 0,
      "developer_low": this.developer_low ? this.developer_low : 0,
      "developer_neutral": this.developer_neutral ? this.developer_neutral : 0,
      "developer_high": this.developer_high ? this.developer_high : 0,
      "implementor_low": this.implementor_low ? this.implementor_low : 0,
      "implementor_neutral": this.implementor_neutral ? this.implementor_neutral : 0,
      "implementor_high": this.implementor_high ? this.implementor_high : 0,
      "integrator": this.integrator ?  this.integrator : 0,
      "highest_score": this.highest_score ? this.highest_score : 0,
      "app_type": "Group Profile Plus",
      "pdf_type": "letter",
      "email": "sarah@blairmiller.com",
      // "today_date": this.date,
      "content_type": 'pdf',
      "profile_type": "Ask",
      "description": "Look at your graph. What do you notice? What, if anything, is surprising? Where does this group need to pay deliberate attention so they can succeed? Think of a project or a challenge this group has recently been engaged in. Describe how the group approached the project using the group profile as a guide.",
      "footer_imptext": "FourSight® Group Profile",
      "footer_text": "provides a snapshot of how a group's energy will likely rise and fall as people work together through the four stages of the universal problem solving process. The numbers indicate how many individuals in the group have a high, neutral, or low thinking preference for each stage.",
      "remember": "Preference <span>=</span> Energy",
      "team_des": "FourSight is a measure of thinking preference, not ability. A preference is a measure of energy, not talent. People with a high preference tend to gravitate to that stage of the problem-solving process. People with a low preference tend to move quickly through it. People with a neutral preference tend to do the work and move on. All three approaches can lead to problem-solving success. Teams are more likely to succeed when people are both self-aware and process aware.",
      "footer_des": null,
    }
    console.log("args for team", this.args)
    return this.args;
  }

   public setArgs(currentTeam) {
  }

}
